import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export function useFireVigency(formRef: any) {
	// estados internos do hook
	const [showAlert, setShowAlert] = useState(false);
	const [vigencyStart, setVigencyStart] = useState<string>("");
	const [vigencyMonths, setVigencyMonths] = useState<number>(12);
	const [vigencyEnd, setVigencyEnd] = useState<string>("");

	// limites
	const today = dayjs.utc();
	const minDateObj = today.subtract(45, "day");
	const maxDateObj = today.add(25, "day");

	const minDateFormatted = minDateObj.format("DD/MM/YYYY");
	const maxDateFormatted = maxDateObj.format("DD/MM/YYYY");

	// inicialização vinda do form (modo edição)
	useEffect(() => {
		if (!formRef?.current) return;

		const initialStart = formRef.current.getFieldValue?.("validity_start");
		const initialMonths = formRef.current.getFieldValue?.("monthly_validity");
		const initialEnd = formRef.current.getFieldValue?.("validity_end");

		const startDate = initialStart && dayjs(initialStart).isValid() ? dayjs(initialStart) : today;

		const months = initialMonths && Number(initialMonths) > 0 ? Number(initialMonths) : 12;

		const endDate = initialEnd && dayjs(initialEnd).isValid() ? dayjs(initialEnd) : startDate.add(months, "month");

		setVigencyStart(startDate.format("YYYY-MM-DD"));
		setVigencyMonths(months);
		setVigencyEnd(endDate.format("YYYY-MM-DD"));
	}, [formRef]);

	// sempre recalcula a data final
	useEffect(() => {
		if (!vigencyStart || !vigencyMonths) return;

		const newEnd = dayjs(vigencyStart).add(vigencyMonths, "month").format("YYYY-MM-DD");

		setVigencyEnd(newEnd);

		formRef?.current?.setFieldValue?.("validity_end", newEnd);
	}, [vigencyStart, vigencyMonths]);

	// sincroniza com formRef
	useEffect(() => {
		if (!formRef?.current) return;

		formRef.current.setFieldValue("validity_start", vigencyStart);
		formRef.current.setFieldValue("monthly_validity", vigencyMonths);
		formRef.current.setFieldValue("validity_end", vigencyEnd);
	}, [vigencyStart, vigencyMonths, vigencyEnd]);

	// mudança da data com validação automática
	const handleVigencyStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		if (!value) return;

		const newDate = dayjs.utc(value, "YYYY-MM-DD", true);
		if (!newDate.isValid()) return;

		let adjusted = newDate;
		let invalid = false;

		if (newDate.isAfter(maxDateObj)) {
			adjusted = maxDateObj;
			invalid = true;
		} else if (newDate.isBefore(minDateObj)) {
			adjusted = minDateObj;
			invalid = true;
		}

		setVigencyStart(adjusted.format("YYYY-MM-DD"));

		if (invalid) setShowAlert(true);
	};

	// meses
	const handleVigencyMonthsChange = (value: number) => {
		setVigencyMonths(value);
	};

	// esconder alerta
	useEffect(() => {
		if (!showAlert) return;
		const t = setTimeout(() => setShowAlert(false), 8000);
		return () => clearTimeout(t);
	}, [showAlert]);

	return {
		showAlert,
		vigencyStart,
		vigencyMonths,
		vigencyEnd,
		minDateObj,
		maxDateObj,
		minDateFormatted,
		maxDateFormatted,
		handleVigencyStartChange,
		handleVigencyMonthsChange,
	};
}
